//used in HOOKAH STORE
export const DefaultCategory = `
    primary_category {
        name
        url_path
    }
`
